import { useParams } from "react-router-dom";

import useUserProfile from "../hooks/useUserProfile";

import userPhoto from "../assets/def_profile_photo.png";

import Typography from "@mui/material/Typography";

function UserProfile() {
  const { username } = useParams();
  const [userProfile, error] = useUserProfile(username);
  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      {userProfile && (
        <div className="profile">
          <Typography
            variant="h1"
            className="capitalize"
            component="div"
            sx={{ flexGrow: 0 }}
          >
            {`${userProfile.username}'s Profile`}
          </Typography>
          <img
            alt="a bowl of noodles"
            className="user-photo"
            src={userPhoto}
            style={{ marginTop: "30px" }}
          />
          <h3 className="subheader">Bio</h3>
          <span>{userProfile.bio}</span>
          <h3 className="subheader">Favorite Food</h3>
          <span>{userProfile.favorite_food}</span>
        </div>
      )}
    </div>
  );
}

export default UserProfile;
